import { Component, input, OnInit, output } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { AngularModule, MaterialModule } from '@shared/modules';

// Validador personalizado
function strictEmailValidator(control: AbstractControl): ValidationErrors | null {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const value = control.value;

  if (value && !emailRegex.test(value)) {
    return { strictEmail: true };
  }
  return null;
}

@Component({
  selector: 'app-input-email',
  standalone: true,
  imports: [AngularModule, MaterialModule],
  templateUrl: './input-email.component.html',
  styleUrls: ['./input-email.component.scss'],
})
export class InputEmailComponent implements OnInit {
  label = input.required<string>();
  control = input.required<FormControl>();
  isClear = input<boolean>(true);
  maxLength = input<number>(50);
  minLength = input<number>(0);
  isRequired = input<boolean>(false);

  clearInput = output<void>();
  minLengthError = output<void>();
  invalidEmailError = output<void>();

  ngOnInit() {
    if (this.isRequired() === true) {
      this.control().setValidators([Validators.required, Validators.email, strictEmailValidator, Validators.minLength(this.minLength()), Validators.maxLength(this.maxLength())]);
    } else {
      this.control().setValidators([Validators.email, strictEmailValidator, Validators.minLength(this.minLength()), Validators.maxLength(this.maxLength())]);
    }

    this.control().updateValueAndValidity();
  }

  clear(): void {
    this.control().setValue('');
    this.clearInput.emit();
  }

  public limitInputLength(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    const cursorPosition = input.selectionStart || 0;
    const currentValue = input.value;

    if (this.isControlKey(key)) return;
    if (key === ' ' && (cursorPosition === 0 || currentValue.length === 0)) {
      event.preventDefault();
      return;
    }

    if (key === ' ' && currentValue[cursorPosition - 1] === ' ') {
      event.preventDefault();
      return;
    }

    if (!this.isValidChar(key) && key !== ' ') {
      event.preventDefault();
      return;
    }

    if (currentValue.length >= this.maxLength() && key !== 'Backspace' && key !== 'Delete') {
      event.preventDefault();
      return;
    }

    // Validar después de la entrada
    setTimeout(() => {
      const updatedValue = input.value;
      this.control().setValue(updatedValue);
      this.control().updateValueAndValidity();

      if (this.control().errors) {
        if (this.control().errors?.['minLength']) {
          this.minLengthError.emit();
        }
        if (this.control().errors?.['email'] || this.control().errors?.['strictEmail']) {
          this.invalidEmailError.emit();
        }
      }
    }, 0);
  }

  private isValidChar(char: string): boolean {
    const validChars = /^[0-9a-zA-Z@._-]$/;
    return validChars.test(char);
  }

  private isControlKey(key: string): boolean {
    return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab'].includes(key);
  }
}
